((Drupal, once) => {
  /**
   * Implement Mutation Observer for hero, so it can attach analytics handler.
   *
   * @type {{attach(*): void}}
   */
  Drupal.behaviors.jnjmdcHeroAnalytics = {
    attach() {
      const analyticsElementsObserver = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.target) {
            Drupal.behaviors.jnjmdcAnalyticsCustomEventTrackingLinks.attach(
              mutation.target
            );
          }
        });
      });

      const elements = once(
        'jnjmdc-hero-analytics',
        '[react-component="hero_card"],[react-component="middleware-modal"]'
      );

      elements.forEach(element => {
        analyticsElementsObserver.observe(element, {
          childList: true,
          subtree: true,
        });
      });
    },
  };
})(Drupal, once);
